module.exports = __webpack_public_path__ + "static/media/person.596f627d.jpg";